import { URL_API } from 'src/configs/keys'
import httpService from 'src/helpers/httpService'
import baseActions from 'src/helpers/redux/baseActions'

const master = 'event-participant'

export const actionType = (action) => {
  return {
    request: `${action}_${master}_request`.toUpperCase(),
    success: `${action}_${master}_success`.toUpperCase(),
    error: `${action}_${master}_error`.toUpperCase(),
  }
}

const request = httpService()

export default {
  ...baseActions(master, URL_API, actionType),
  markPresence: (data) => {
    return (dispatch) => {
      dispatch({ type: actionType('markPresence').request })
      return request.post(`${URL_API}/${master}/attendance`, data).then(
        (response) => {
          dispatch({ type: actionType('markPresence').success })
          return response.data
        },
        (error) => {
          dispatch({ type: actionType('markPresence').error })
          throw error.response
        },
      )
    }
  },
}
